export default (tourProduct) => {
    const tour = tourProduct.get('product');
    const room = tour?.get('room');
    const roomDescription = room?.description;

    const identity = tourProduct.get('id');
    const hotelId = tour?.get('hotel');
    const operatorId = tour?.get('operator').id;
    const countryId = window.appConfig.hotelInfo.country;
    const roomDescriptionAvailable = +!!roomDescription;

    let roomCategoryId = null;
    let roomName = null;
    let descriptionSource = null;
    let descriptionStatus = null;
    let roomPhotosCount = null;

    if (room) {
        roomCategoryId = room.category;
        roomName = `${room.standardName || null} | ${room.name}`;
    }

    if (roomDescription) {
        descriptionSource = room.source;
        descriptionStatus = room.descriptionStatus;
        roomPhotosCount = room.photos?.length;
    }

    return {
        roomCategoryId,
        roomName,
        descriptionSource,
        descriptionStatus,
        roomPhotosCount,
        roomDescriptionAvailable,
        identity,
        hotelId,
        operatorId,
        countryId,
    };
};